import React, { useCallback } from 'react';
import { Grid, Card, CardContent, Divider } from '@mui/material';
import { gridSpacing } from '../../../common/themes/constants';
import ReviewCardGroup from './EnrollClinic/ReviewInformation';
import { isEmpty, omit } from 'lodash';

import * as Roles from '../../auth/constants/Role';


export default function EnrollPsrReviewInfo({ data, onEditUser, onEditClinic, onEditProvider, permissions = [], notificationSettings = [] }) {
  const { users, clinic, providers } = data;
  const parseUserData = useCallback(
    userData => {
      const parsedUserdata =
        !isEmpty(userData) &&
          !isEmpty(permissions) &&
          !isEmpty(notificationSettings)
          ? {
            ...userData,
            role_id: Object.values(Roles).find(r => r.id === userData.role_id)?.label,
            notification: notificationSettings.filter(
              (_val, index) =>
                userData.notification
                  .toString(2)
                  .split('')
                  .reverse()[index] === '1'
            ),
            permission: permissions.filter(
              (_val, index) =>
                userData.permission
                  .toString(2)
                  .split('')
                  .reverse()[index] === '1',
            )
          }
          : {};
      return parsedUserdata;
    },
    [permissions, notificationSettings],
  );

  return (
    <Card>
      <CardContent>
        <Grid container direction="column" spacing={gridSpacing}>

          <ReviewCardGroup
            title="Clinic details"
            data={omit(clinic, ['users', 'providers'])}
            onEditGroup={onEditClinic}
          />

          <Grid item>
            <Divider />
          </Grid>
          {!isEmpty(providers) && providers.map(provider => {
            if(provider.is_default) { return null; }
            return (
              <ReviewCardGroup
                title="Provider Details"
                key={`details-provider$-${provider.firstname}`}
                data={provider}
                onEditGroup={onEditProvider}
              />
            );
          })}

          {!isEmpty(users) && users.map(user => {
            return (
              <>
                <Grid item>
                  <Divider />
                </Grid>

                <ReviewCardGroup
                  key={`details-user$-${user.email}`}
                  title="User details"
                  data={parseUserData(user)}
                  onEditGroup={user.role_id !== Roles.ROLE_PROVIDER.id ? onEditUser : null }
                />
              </>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
}

